import { GetHasOfflineShootingQueryParamsType } from '@/modules/OfflineFiles/queries/getHasOfflineShooting/getHasOfflineShootingQuery.type';
import { getHasOfflineShootingFunction } from '@/modules/OfflineFiles/queries/getHasOfflineShooting/getHasOfflineShootingQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getHasOfflineShootingQueryOptions = (
  params: GetHasOfflineShootingQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GetHasOfflineShooting', params],
    queryFn: () => getHasOfflineShootingFunction(params),
    enabled: true,
    gcTime: 1,
    staleTime: 1,
    refetchOnMount: true,
    meta: { onSuccess: params.onSuccess },
  });
};
